import { hasPermission } from './permissionResolver';
export function hasAiAssistantAccess(user) {
	if (hasPermission(user, 'ai.assistant.use')) return true;
	if ([...(user?.permissions?.deny || []), ...(user?.permissionOverrides?.deny || [])].includes('ai.assistant.use')) return false;
	const roles = Array.isArray(user?.role) ? user.role : [user?.role];
	if (roles.some((role) => role?.permissions?.some((permission) => permission.name === 'ai' && permission.crud?.useAssistant !== undefined))) return false;
	return hasPermission(user, 'ai.read');
}
